import React from 'react';
import {StyleSheet, View} from 'react-native';
import type {Meta, StoryObj} from '@storybook/react-native-web-vite';

import Text from '../../ui-controls/Text';

import Spacer, {SpacerSize} from './Spacer';

const meta = {
  title: 'Components/Primitives/Spacer',
  component: Spacer,
  parameters: {
    docs: {
      description: {
        component:
          'Vertical spacer mirroring the Figma `SpacerMob` component. Only the four design heights ' +
          '(16, 24, 40, 64) are available — rewards sign-up layouts are spacer-driven, not margin-driven.',
      },
    },
  },
  args: {size: 24},
} satisfies Meta<typeof Spacer>;

export default meta;

type Story = StoryObj<typeof meta>;

const SIZES: SpacerSize[] = [16, 24, 40, 64];

export const AllSizes: Story = {
  render: () => (
    <View style={styles.container}>
      {SIZES.map(size => (
        <View key={size}>
          <Text style={styles.label}>size={size}</Text>
          <View style={styles.band}>
            <Spacer size={size} />
          </View>
        </View>
      ))}
    </View>
  ),
};

export const Default: Story = {
  render: args => (
    <View style={styles.container}>
      <Text style={styles.label}>Above</Text>
      <Spacer {...args} />
      <Text style={styles.label}>Below</Text>
    </View>
  ),
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 8,
  },
  label: {
    fontSize: 14,
  },
  band: {
    backgroundColor: '#cfe3ff',
  },
});
